/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const startMission = /* GraphQL */ `mutation StartMission($input: StartMissionInput!) {
  startMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.StartMissionMutationVariables,
  APITypes.StartMissionMutation
>;
export const archiveMission = /* GraphQL */ `mutation ArchiveMission($input: ArchiveMissionInput!) {
  archiveMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.ArchiveMissionMutationVariables,
  APITypes.ArchiveMissionMutation
>;
export const assignMission = /* GraphQL */ `mutation AssignMission($input: AssignMissionInput!) {
  assignMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.AssignMissionMutationVariables,
  APITypes.AssignMissionMutation
>;
export const cancelMission = /* GraphQL */ `mutation CancelMission($input: CancelMissionInput!) {
  cancelMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.CancelMissionMutationVariables,
  APITypes.CancelMissionMutation
>;
export const continueStream = /* GraphQL */ `mutation ContinueStream($input: ContinueStreamInput!) {
  continueStream(input: $input) {
    cameraID
    vin
  }
}
` as GeneratedMutation<
  APITypes.ContinueStreamMutationVariables,
  APITypes.ContinueStreamMutation
>;
export const createHub = /* GraphQL */ `mutation CreateHub($input: CreateHubInput!) {
  createHub(input: $input) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.CreateHubMutationVariables,
  APITypes.CreateHubMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    city
    country
    createdAt
    updatedAt
    email
    firstName
    id
    lastName
    phone
    roles {
      id
      name
      createdAt
      updatedAt
      claims {
        pattern
        createdAt
        updatedAt
      }
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const deleteVehicleDeviationsByVin = /* GraphQL */ `mutation DeleteVehicleDeviationsByVin($input: DeleteVehicleDeviationsInput!) {
  deleteVehicleDeviationsByVin(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleDeviationsByVinMutationVariables,
  APITypes.DeleteVehicleDeviationsByVinMutation
>;
export const resetMission = /* GraphQL */ `mutation ResetMission($input: ResetMissionInput!) {
  resetMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.ResetMissionMutationVariables,
  APITypes.ResetMissionMutation
>;
export const triggerVehicleCommand = /* GraphQL */ `mutation TriggerVehicleCommand($input: VehicleCommandInput!) {
  triggerVehicleCommand(input: $input) {
    command
    errorMessage
    invocationId
    isSuccess
    receivedByVehicleAt
    sentToVehicleAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.TriggerVehicleCommandMutationVariables,
  APITypes.TriggerVehicleCommandMutation
>;
export const updateHub = /* GraphQL */ `mutation UpdateHub($input: UpdateHubInput!) {
  updateHub(input: $input) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.UpdateHubMutationVariables,
  APITypes.UpdateHubMutation
>;
export const updatedMission = /* GraphQL */ `mutation UpdatedMission($input: UpdatedMissionInput!) {
  updatedMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionMutationVariables,
  APITypes.UpdatedMissionMutation
>;
export const updatedVehicle = /* GraphQL */ `mutation UpdatedVehicle($input: UpdatedVehicleInput) {
  updatedVehicle(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleMutationVariables,
  APITypes.UpdatedVehicleMutation
>;
export const updatedVehicleByVin = /* GraphQL */ `mutation UpdatedVehicleByVin($input: UpdatedVehicleByVinInput) {
  updatedVehicleByVin(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleByVinMutationVariables,
  APITypes.UpdatedVehicleByVinMutation
>;
export const updatedVideoStreamingError = /* GraphQL */ `mutation UpdatedVideoStreamingError($input: UpdatedVideoStreamingErrorInput!) {
  updatedVideoStreamingError(input: $input) {
    cameraID
    errorCode
    errorMessage
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVideoStreamingErrorMutationVariables,
  APITypes.UpdatedVideoStreamingErrorMutation
>;
export const updateFleetById = /* GraphQL */ `mutation UpdateFleetById($input: UpdatedFleetInput!) {
  updateFleetById(input: $input) {
    id
    name
    createdAt
    updatedAt
    teams {
      id
      name
    }
    numberOfVehicles
  }
}
` as GeneratedMutation<
  APITypes.UpdateFleetByIdMutationVariables,
  APITypes.UpdateFleetByIdMutation
>;
export const updateUserById = /* GraphQL */ `mutation UpdateUserById($input: UpdatedUserInput!) {
  updateUserById(input: $input) {
    city
    country
    createdAt
    updatedAt
    email
    firstName
    id
    lastName
    phone
    roles {
      id
      name
      createdAt
      updatedAt
      claims {
        pattern
        createdAt
        updatedAt
      }
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserByIdMutationVariables,
  APITypes.UpdateUserByIdMutation
>;
export const resetPasswordById = /* GraphQL */ `mutation ResetPasswordById($input: ID!) {
  resetPasswordById(input: $input) {
    ... on ResetPasswordSuccessful {
      statusCode
    }
    ... on UserNotActiveError {
      statusCode
      errorCode
    }
    ... on ValidationError {
      statusCode
      errorCode
    }
    ... on SystemError {
      statusCode
      errorCode
    }
    ... on NotFoundError {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.ResetPasswordByIdMutationVariables,
  APITypes.ResetPasswordByIdMutation
>;
export const deleteUserById = /* GraphQL */ `mutation DeleteUserById($input: ID!) {
  deleteUserById(input: $input) {
    ... on DeleteUserSuccessful {
      statusCode
    }
    ... on SelfDeleteError {
      statusCode
      errorCode
    }
    ... on ValidationError {
      statusCode
      errorCode
    }
    ... on SystemError {
      statusCode
      errorCode
    }
    ... on NotFoundError {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserByIdMutationVariables,
  APITypes.DeleteUserByIdMutation
>;
export const createFleet = /* GraphQL */ `mutation CreateFleet($input: CreateFleetInput!) {
  createFleet(input: $input) {
    id
    name
    createdAt
    updatedAt
    teams {
      id
      name
    }
    numberOfVehicles
  }
}
` as GeneratedMutation<
  APITypes.CreateFleetMutationVariables,
  APITypes.CreateFleetMutation
>;
export const createTeam = /* GraphQL */ `mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    id
    name
    users
    fleets
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMutationVariables,
  APITypes.CreateTeamMutation
>;
export const updateTeam = /* GraphQL */ `mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    id
    name
    users
    fleets
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMutationVariables,
  APITypes.UpdateTeamMutation
>;
export const updatedMissionV2 = /* GraphQL */ `mutation UpdatedMissionV2($input: UpdatedMissionInputV2!) {
  updatedMissionV2(input: $input) {
    id
    vin
    timestamp
    version
    actualArrivalTime
    actualStartTime
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    name
    plannedArrivalTime
    progressDetails {
      ttl
      value {
        eta
        remainingDistanceInMeters
        traveledDistanceInMeters
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      positions {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionV2MutationVariables,
  APITypes.UpdatedMissionV2Mutation
>;
export const updatedVehicleV2 = /* GraphQL */ `mutation UpdatedVehicleV2($input: UpdatedVehicleInputV2!) {
  updatedVehicleV2(input: $input) {
    vin
    timestamp
    activeMissionId {
      ttl
      value {
        data
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    adsState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    connectivityStatus {
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    deviations {
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          sentAt
          severity
          relatedDeviations
          resolvedAt
          state
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    driverMode {
      ttl
      value {
        mode
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    drivingState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      ttl
      value {
        data {
          value
          executionPhase
          causes
          startedAt
          triggerBy
          mrmType
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    speedMs {
      ttl
      value {
        speedMs
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleV2MutationVariables,
  APITypes.UpdatedVehicleV2Mutation
>;
export const deleteVehicleDeviationsByVinV2 = /* GraphQL */ `mutation DeleteVehicleDeviationsByVinV2($input: DeleteVehicleDeviationsInput!) {
  deleteVehicleDeviationsByVinV2(input: $input) {
    ... on VehicleV2 {
      vin
      timestamp
      activeMissionId {
        ttl
        value {
          data
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      adsState {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      connectivityStatus {
        ttl
        value {
          expectDisconnection
          latency
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      deviations {
        ttl
        value {
          deviation {
            category
            description
            id
            isBlocking
            origin
            sentAt
            severity
            relatedDeviations
            resolvedAt
            state
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      driverMode {
        ttl
        value {
          mode
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      drivingState {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      fleetId
      latestVehicleUpdate
      licensePlate
      mrmState {
        ttl
        value {
          data {
            value
            executionPhase
            causes
            startedAt
            triggerBy
            mrmType
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      name
      owners {
        email
        fullName
        id
        phoneNumber
        position
      }
      position {
        ttl
        value {
          position {
            altitude
            heading
            latitude
            longitude
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      speedMs {
        ttl
        value {
          speedMs
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleDeviationsByVinV2MutationVariables,
  APITypes.DeleteVehicleDeviationsByVinV2Mutation
>;
export const createMissionV2 = /* GraphQL */ `mutation CreateMissionV2($input: CreateMissionInputV2!) {
  createMissionV2(input: $input) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.CreateMissionV2MutationVariables,
  APITypes.CreateMissionV2Mutation
>;
export const startMissionV2 = /* GraphQL */ `mutation StartMissionV2($input: StartMissionInput!) {
  startMissionV2(input: $input) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.StartMissionV2MutationVariables,
  APITypes.StartMissionV2Mutation
>;
export const resetMissionV2 = /* GraphQL */ `mutation ResetMissionV2($input: ResetMissionInput!) {
  resetMissionV2(input: $input) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.ResetMissionV2MutationVariables,
  APITypes.ResetMissionV2Mutation
>;
export const archiveMissionV2 = /* GraphQL */ `mutation ArchiveMissionV2($input: ArchiveMissionInput!) {
  archiveMissionV2(input: $input) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.ArchiveMissionV2MutationVariables,
  APITypes.ArchiveMissionV2Mutation
>;
export const cancelMissionV2 = /* GraphQL */ `mutation CancelMissionV2($input: CancelMissionInput!) {
  cancelMissionV2(input: $input) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedMutation<
  APITypes.CancelMissionV2MutationVariables,
  APITypes.CancelMissionV2Mutation
>;
export const updatedMissionV3 = /* GraphQL */ `mutation UpdatedMissionV3($input: UpdatedMissionInputV3!) {
  updatedMissionV3(input: $input) {
    vin
    fleetId
    payload {
      ... on MissionV2 {
        id
        vin
        timestamp
        version
        actualArrivalTime
        actualStartTime
        description
        events {
          createdAt
          position {
            altitude
            heading
            latitude
            longitude
          }
          type
        }
        fleetId
        name
        plannedArrivalTime
        progressDetails {
          ttl
          value {
            eta
            remainingDistanceInMeters
            traveledDistanceInMeters
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        route {
          createdAt
          durationInSeconds
          externalRouteId
          landingHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          launchHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          predefinedRouteId
          totalDistanceInMeters
          updatedAt
          positions {
            altitude
            heading
            latitude
            longitude
          }
        }
        state {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
      }
      ... on MissionUnassigned {
        vin
        timestamp
        version
        fleetId
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionV3MutationVariables,
  APITypes.UpdatedMissionV3Mutation
>;
